import { Injectable } from '@angular/core';
import { AsyncSubject } from 'rxjs/AsyncSubject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
//import { ToastController, Toast } from 'ionic-angular';
import 'rxjs';

//import { RcsAppConfig } from '../../assets/app.config';
import { JobPrototyp } from '../../assets/shared/job.object';
import { RcsStackProvider } from '../rcs-stack-service/rcs-stack-service';
//import { RcsStackDbProvider } from '../rcs-stack-db-service/rcs-stack-db-service';
import { RcsConnectorOdooProvider } from '../rcs-connector-odoo/rcs-connector-odoo';
import { RcsConnectorIndexDbProvider } from '../rcs-connector-index-db/rcs-connector-index-db';
import { RcsLogin } from "../../assets/shared/rcs-login.class";
import { ReplacementPartsProvider } from '../replacement-parts/replacement-parts';
import { DraftServiceProvider } from '../draft-service/draft-service';
import {RcsStackDbProvider} from "../rcs-stack-db-service/rcs-stack-db-service";

@Injectable()
export class RcsSyncDataProvider{

    //private toast: Toast
    private sub_module = {
      'orderline': 'rcs.kdienst.auftrag.line',
      'workline': 'rcs.kdienst.auftrag.zeit',
      'schaetzline': 'rcs.kdienst.auftrag.schaetzzeit'
    }

    constructor(
      //private app_conf: RcsAppConfig,
      private stack_service: RcsStackProvider,
      private odoo_service: RcsConnectorOdooProvider,
      private stack_db: RcsStackDbProvider,
      private data_db_service: RcsConnectorIndexDbProvider,
      //private toast_controller: ToastController,
      private replacement_parts_service: ReplacementPartsProvider,
      private draft: DraftServiceProvider,
    ){}

    // Synchronisiert Jobs und setzt die Finish Flag
    public sync_jobs(login: RcsLogin): AsyncSubject<any> {
      let flag_finish = new AsyncSubject();
      let stack_read = new AsyncSubject();
      let jobs: {[id: number]: any} = Array();

      this.stack_db.get_stack_ids().subscribe(result => {
        let stack_count = Object.keys(result).length;
        if (stack_count == 0) {
          stack_read.complete();
        } else {
          for (const job_index in result) {
            const job_id = result[job_index];
            this.data_db_service.get_record_by_key('jobs', job_id).subscribe(result => {
              console.log(result);
              jobs[job_id] = result;
              stack_read.next(result);
              if (stack_count >= Object.keys(jobs).length) {
                stack_read.complete();
              }
            });
          }
        }
      });

      stack_read.subscribe({
        next: (x) => console.log(Object.keys(jobs).length, x),
        complete: () => {
          let job_count = this.get_jobs(login, jobs);
          this.data_db_service.clear('jobs').subscribe(
            () => {
              this.odoo_service.count_records(login, 'rcs.kdienst.auftrag', [], {"filter_my": 1, "from_app": 1})
                .map(amount => amount.json().result)
                .subscribe(
                  amount => {
                    job_count.subscribe(
                      job_count => {
                        if (amount === job_count) {
                          // Flag manuell synchronisieren entfernen
                          localStorage.removeItem('manual_sync_needed');
                          flag_finish.next(true);
                          flag_finish.complete();
                        }
                      },
                      error => {
                        flag_finish.complete();
                      })
                  })
            },
            error => {
              console.log(error);
              flag_finish.next(true);
              flag_finish.complete();
            }
          )
          /*setTimeout(() => {
            console.log("END");
            flag_finish.next(true);
            flag_finish.complete();
          }, 10000);*/
        }
      });

      return flag_finish;
    }

    // Synchronisiert die Aufträge aus dem Odoo
    public get_jobs(login: RcsLogin, stacked_jobs: any = null): BehaviorSubject<any>{
      let count = 0;
      let job_count = new BehaviorSubject(count);
      let prototyp = new JobPrototyp();
      this.odoo_service.get(login, prototyp, 'rcs.kdienst.auftrag', [], 0, 0, {"filter_my":1, "from_app": 1}).subscribe(
        job_object_guardian => {
          if (typeof job_object_guardian === 'boolean') {
            job_count.complete();
          } else if (typeof job_object_guardian !== 'undefined'){
            job_object_guardian.subscribe(
              job => {
                if (stacked_jobs && job.id in stacked_jobs && stacked_jobs[job.id] != undefined) {
                  console.log("STACKED", stacked_jobs[job.id]);
                  this.data_db_service.add('jobs', stacked_jobs[job.id], job.id).subscribe(
                    () => {
                      count++;
                      job_count.next(count);
                    },
                    error => {
                      console.log(error)
                    }
                  );
                } else {
                  console.log("LIVE", job);
                  if (job.state_name === 'Ersatzteilabholung') {
                    this.replacement_parts_service.sync_replacement_parts(job.abholbuchung, job.id);
                  }
                  this.draft.delete_safe(job);
                  this.data_db_service.add('jobs', job, job.id).subscribe(
                    () => {
                      count++;
                      job_count.next(count);
                    },
                    error => {
                      console.log(error)
                    }
                  );
                }
              })
          }
        },
        error => {
          job_count.complete();
        });
      return job_count;
    }

    // Synchronisiert die Validation_Fields aus dem Odoo
    public get_validation_fields(){
      let filter = [["name", "=", "Lieferanten"]];
      this.data_db_service.get_record_by_key('login', 'user_login').subscribe(
        (login) => {
          this.odoo_service.search_read(login, 'ir.filters', filter, [], 0, {}).subscribe(
            (result) => {
              let response = result.json().result;
              for (let validation_field of response){
                this.data_db_service.update_record('validation_fields', validation_field, validation_field.id);
              }
            }
          )
        }
      )
    }

    // Update einen Auftrag aus dem Odoo
    public update_job(login, job:any){
      let main_module = Object.assign({}, job);
      let keys = Object.keys(main_module);
      let sub_module = []
      for (let key of keys){
        if (typeof(this.sub_module[key]) !== 'undefined'){
          sub_module.push({ 'name': this.sub_module[key], 'value': main_module[key]});
          delete main_module[key];
        }
      }
      this.update_main_module(login, main_module);
      return this.update_sub_module(login, sub_module, main_module.id);
    }

    // Updatet das Main_Module des Auftrages
    private update_main_module(login:any, module:any):void{
      let keys = Object.keys(module)
      for (let key of keys){
        if (typeof(module[key]) === 'object'){
          delete module[key]
        }
      }
      this.stack_service.add_task(2, 'update_record', [login, 'rcs.kdienst.auftrag', module.id, module], module.id);
    }

    // Updatet das Sub_Module des Auftrages
    private update_sub_module(login, module:any, main_module_id:number):Array<any>{
      let sub_modul_ids = [];
      for (let modul of module){
        for(let item of modul.value){
          sub_modul_ids.push(item.id);
          item['order_id'] = main_module_id;
          let query = {}
          let keys = Object.keys(item);
          for (let key of keys){
            if (typeof(item[key]) === 'object' && item[key] !== null){
              query[key] = item[key][0];
            }else{
              query[key] = item[key];
            }
          }
          console.info("ITEMMM", item);
          if (item.state === 'delete'){
            this.stack_service.add_task(2, 'call', [login, modul.name, 'unlink', [item.id], item.id], item.id);
          }else if (item.state_app === 'new'){
            this.stack_service.add_task(2, 'create_record', [login, modul.name, query], item.id);
          }else{
            this.stack_service.add_task(2, 'update_record', [login, modul.name, item.id, query], item.id);
          }
        }
      }
      return sub_modul_ids;
    }

    public sync_job_after_update(login, job_id:number, model_ids):AsyncSubject<any>{
      let prototyp = new JobPrototyp();
      let result_guardian = new AsyncSubject();
      if (localStorage.getItem("online_status") == 'true'){
        this.stack_service.overwatch_task_processes(model_ids).subscribe(
          success => {
            this.odoo_service.get(login, prototyp, 'rcs.kdienst.auftrag', [["id", "=", job_id]], 0, 0, {"filter_my": 1}).subscribe(
              (response) => {
                let monteur_id = this.odoo_service.simple_search_read(login, 'rcs.kdienst.monteur', [["employee_id.login","=",login.username]], ["id"]);
                Observable.forkJoin.apply(this, [ response, monteur_id ]).subscribe( (data) => {
                  let job = data[0]
                  job['monteur'] = data[1].json().result[0];
                  this.data_db_service.update_record('jobs', job, job.id);
                  result_guardian.next(job);
                  result_guardian.complete();
                });
              }
            )
          })
      }else{
        result_guardian.next(false);
        result_guardian.complete();
      }
      return result_guardian;
    }
}



// WEBPACK FOOTER //
// ./src/providers/rcs-sync-data-service/rcs-sync-data-service.ts